import ComplaintsDialog from './ComplaintsDialog';

export default ComplaintsDialog;
